module.exports = __webpack_public_path__ + "img/bg_space_tr3.5f21abc0.png";